export const THUMBNAIL_IDENTIFIER = "_THUMB";
export const THUMBNAIL_WIDTH = 200; // in px
export const MAX_FILE_DIMENSION = 3000; // 3000px (width or height)
export const MAX_UPLOAD_FILE_SIZE = 500 * 1024 ** 2; // 500 Megabytes
export const SIGNED_URL_EXPIRATION_MS = 86400000; // 1 day expiration
export const SIGNED_URL_EXPIRATION_SEC = SIGNED_URL_EXPIRATION_MS / 1000; // 1 day expiration
